import { useTranslation } from 'react-i18next';

const ProjectSolutionCalculationResultAlert = (props) => {

  const { t } = useTranslation();

  const errors = () => {
    return !( props.resSchottbelegung.errors === undefined || (Array.isArray(props.resSchottbelegung.errors) && props.resSchottbelegung.errors.length === 0) || props.resSchottbelegung.errors === null)
  }

    const currentCoverage = () => {
      if (errors()) {
        return t('product_solution.calculation_result.calculation_not_possible')
      } else {
        return t('product_solution.calculation_result.headline.coverage_text', {summe: props.resSchottbelegung.sum_in_percent, maximum: props.resSchottbelegung.max_area_allocation_in_percent})
      }
    }

    return  currentCoverage()

}

export default ProjectSolutionCalculationResultAlert



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectSolutionCalculationResultAlert.js